<template>
    <div>
        <div class="hot" @click="$emit('next', 4)"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        };
    }
};
</script>

<style lang="stylus" scoped>
.hot
    position absolute
    left 5%
    bottom 20%
    size .5rem
    opacity 0
    transform scale(0)
    background url('/img/xj/snow.png') 0 0/100% 100% no-repeat
    animation hot 1s, rotate 2s infinite linear 1s
    animation-fill-mode forwards, none
</style>
